import { render } from "./BaseInfoForCreativity.vue?vue&type=template&id=945f9014&scoped=true"
import script from "./BaseInfoForCreativity.vue?vue&type=script&lang=js"
export * from "./BaseInfoForCreativity.vue?vue&type=script&lang=js"

import "./BaseInfoForCreativity.vue?vue&type=style&index=0&id=945f9014&scoped=true&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-945f9014"]])

export default __exports__